import React from "react";
import { Route, Routes } from "react-router-dom";
import Rsvp from "../pages/Rsvp";
import NotFound from "../pages/NotFound";
import Banner from "../pages/banner/banner";
export const MainRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Banner />} />
      <Route path="/lm1812milad/*" element={<Rsvp/>} />
      <Route path="/gd1812welcome/*" element={<Rsvp/>} />
      <Route path="/qn1912mehndi/*" element={<Rsvp/>} />
      <Route path="/wd2112nikkah/*"element={<Rsvp/>} />
      <Route path="/wr2212reception/*" element={<Rsvp/>} />
      <Route path="/bd811shower/*" element={<Rsvp/>} />
      <Route path="/fd1512dinner/*" element={<Rsvp/>} />
      <Route path="/kb1412majlis/*" element={<Rsvp/>} />
      <Route path="" element={<NotFound />} />
    </Routes>
  );
};
